const mutations={
	changeMsgCount(state,msgCount){
		state.msgCount=msgCount
	},
	changeUserName(state,userName){
		state.userName=userName
	},
	
}


export default mutations


// WEBPACK FOOTER //
// ./src/_vuex/mutations.js